import type { NavigateFunction } from 'react-router-dom';

/**
 * Module-level holder for React Router's navigate function.
 * Set once at app root via useGlobalNavigate() hook so that
 * non-React code (Zustand stores, services) can navigate
 * without destroying React state via window.location.href.
 */
let _navigate: NavigateFunction | null = null;

export function setGlobalNavigate(fn: NavigateFunction) {
  _navigate = fn;
}

export function globalNavigate(to: string) {
  if (_navigate) {
    _navigate(to);
  } else {
    // Fallback if called before the hook mounts
    window.location.href = to;
  }
}
